const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// Password-reset and verify-email links are opened both on the web and, ideally, straight in the
// app. Universal Links/App Links only fire when tapped from the OS's own browser or Mail app —
// many mail clients (Gmail, Spark, Outlook) open links in an embedded in-app browser
// (SFSafariViewController on iOS, a Custom Tab on Android) instead, and Apple/Google deliberately
// don't honor Universal/App Links from inside those. A custom URL scheme isn't part of that
// mechanism, though, and still works from an in-app browser (with a one-tap OS confirmation) —
// this is the same fallback technique deep-linking SDKs like Branch/Firebase Dynamic Links use.
// Resolves true if the app took over (the tab went hidden), false otherwise (desktop, or the app
// isn't installed), so the caller can skip doing its own thing and let the app handle it instead.
export function tryOpenApp(path: string): Promise<boolean> {
  if (!isMobileDevice) {
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    let settled = false;
    const finish = (opened: boolean) => {
      if (settled) {
        return;
      }
      settled = true;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      clearTimeout(timer);
      resolve(opened);
    };
    const onVisibilityChange = () => {
      if (document.hidden) {
        finish(true);
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.location.href = `clickfun://${path}`;
    const timer = setTimeout(() => finish(false), 1500);
  });
}
